export class Counter{
    constructor(counterElement, inputElement, removeBinders = false, btnAddToCartELement) {
        this.counterElement = counterElement;
        this.counter = 1;
        this.elements = {
            decrement: counterElement.querySelector('.counter-button--decrement'),
            increment: counterElement.querySelector('.counter-button--increment'),
            counter: {
                container: counterElement.querySelector('.counter-content'),
                value: counterElement.querySelector('.counter-content__value'),
                input: counterElement.querySelector('.counter-content__input')
            }
        }
        this.inputElement = inputElement;
        this.removeBinders = removeBinders;
        this.MAX_VALUE = 99;
        this.btnAddToCartELement = btnAddToCartELement;

        this.init();
    }

    decrement() {
        let nextCounter = (this.counter > 0) ? --this.counter : this.counter;
        this.counter = nextCounter;

    }

    decrementFn() {
        this.debounce(() => {
            this.decrement();
            this.render('is-decrement-hide', 'is-decrement-visible');
            this.updateBtn();
        });
    }

    refreshFn() {
        if (this.elements.counter.input.value > this.MAX_VALUE) this.elements.counter.input.value = this.MAX_VALUE;
        let nextCounter = this.elements.counter.input.value;
        this.counter = nextCounter;
        this.render('is-decrement-hide', 'is-decrement-visible');
        this.updateBtn();
    }

    increment() {
        let nextCounter = (this.counter < this.MAX_VALUE) ? ++this.counter : this.counter;
        this.counter = nextCounter;

    }

    incrementFn() {
        this.debounce(() => {
            this.increment();
            this.render('is-increment-hide', 'is-increment-visible');
            this.updateBtn();
        });
    }

    debounce(callback) {
        setTimeout(callback, 100);
    }

    render(hideClassName, visibleClassName) {
        this.elements.counter.value.classList.add(hideClassName);

        setTimeout(() => {
            this.elements.counter.value.innerText = this.counter;
            this.elements.counter.input.value = this.counter;
            this.elements.counter.value.classList.add(visibleClassName);
        }, 100);

        setTimeout(() => {
            this.elements.counter.value.classList.remove(hideClassName);
            this.elements.counter.value.classList.remove(visibleClassName);
        }, 200);

    }

    updateBtn() {
        let btnAddToCart = (this.btnAddToCartELement) ? this.btnAddToCartELement : this.counterElement.parentElement.querySelector(".btn[data-click='addToCart']");
        let inputQuantidade = document.querySelectorAll('input[data-quantidade-item]');

        if(btnAddToCart)
            btnAddToCart.setAttribute('data-item-qtde', this.counter);

        if(inputQuantidade) {
          Array.prototype.forEach.call(inputQuantidade, el => {
            el.setAttribute('value', this.counter);
          })
        }

        if(this.inputElement)
            this.inputElement.value = this.counter

        this.counterElement.setAttribute('data-item-qtde', this.counter);
    }

    init() {

        if(!this.removeBinders) {

            this.elements.decrement.addEventListener('click', () => {
                this.decrementFn()
            });

            this.elements.increment.addEventListener('click', () => {
                this.incrementFn()
            });


            this.elements.counter.input.addEventListener('input', (e) => {
                let parseValue = parseInt(e.target.value);

                if (!isNaN(parseValue) && parseValue >= 0){
                    if(parseValue > this.MAX_VALUE)
                        this.counter = this.MAX_VALUE;
                    else
                        this.counter = parseValue;

                    this.render();
                    this.updateBtn();
                }
            });

            this.elements.counter.input.addEventListener('focus', (e) => {
                this.elements.counter.container.classList.add('is-input');
            });

            this.elements.counter.input.addEventListener('blur', (e) => {
                this.elements.counter.container.classList.remove('is-input');
                this.render();
                this.updateBtn();
            });

        }

        if(this.counterElement) {
            if(this.counterElement.getAttribute('data-item-qtde')) {
                this.counter = this.counterElement.getAttribute('data-item-qtde');
            }
        }

        this.updateBtn();
        this.render();

    };

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/counter/counter.js